"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePageWithNewLang = void 0;
var react_1 = require("react");
var navigation_1 = require("next/navigation");
var next_intl_1 = require("next-intl");
var usePageWithNewLang = function () {
    var _a = (0, react_1.useState)(false), mounted = _a[0], setMounted = _a[1];
    var pathname = (0, navigation_1.usePathname)();
    var searchParams = (0, navigation_1.useSearchParams)();
    var lang = (0, next_intl_1.useLocale)();
    (0, react_1.useEffect)(function () {
        setMounted(true);
        return function () { return setMounted(false); };
    }, []);
    return (0, react_1.useCallback)(function (lng) {
        if (!mounted)
            return '';
        var existedSearchParams = searchParams.toString();
        if (existedSearchParams && existedSearchParams !== '')
            return (pathname.replace("/".concat(lang), "/".concat(lng)) + "?".concat(existedSearchParams));
        return pathname.replace("/".concat(lang), "/".concat(lng));
    }, [mounted, searchParams, lang, pathname]);
};
exports.usePageWithNewLang = usePageWithNewLang;
